<template>
  <AbstractIssue ref="abstractRef" :event="event" v-bind="$attrs" @open-edit-component="show">
    <template #editComponent>
      <CommonIssueModal
        v-if="renderIssueModal"
        ref="issueModal"
        :event="{ ...event, fileIds: event.Folder?.files.map((f) => f.id) ?? [] }"
      />
    </template>
  </AbstractIssue>
</template>

<script setup lang="ts">
import { type PropType, ref, nextTick } from "vue";
import type { EventListEventFields_Issue_Fragment } from "@/graphql";
import CommonIssueModal from "./modal/CommonIssueModal.vue";
import AbstractIssue from "./AbstractIssue.vue";

defineProps({
  event: {
    type: Object as PropType<EventListEventFields_Issue_Fragment>,
    required: true,
  },
});
const abstractRef = ref<InstanceType<typeof AbstractIssue>>();
const issueModal = ref<null | InstanceType<typeof CommonIssueModal>>(null);
const renderIssueModal = ref(false);
const show = async () => {
  renderIssueModal.value = true;
  await nextTick();
  issueModal.value?.show();
};

defineExpose({
  abstractRef,
});
</script>

<style lang="scss" scoped></style>
